import { createWidgets } from './utils/vueUtils'
// import WidgetNews from './WidgetNews.vue'
import WidgetAnwendungsFavoriten from './WidgetAnwendungsFavoriten.vue'
import WidgetBetriebsmitteilungen from './WidgetBetriebsmitteilungen.vue'
import WidgetRSSFindok from './WidgetRSSFindok.vue'
import WidgetSearch from './WidgetSearch.vue'
import WidgetSearchVab from './WidgetSearchVab.vue'
import WidgetSearchBhagIntranet from './WidgetSearchBhagIntranet.vue'

import WidgetAnwendungsListe from './WidgetAnwendungsListe.vue'
import sharedStore from '@/config/sharedStore'
import WidgetBmfwfLinkanzeige from './WidgetBmfwfLinkanzeige.vue'
import WidgetBmfwfLinkverwaltung from './WidgetBmfwfLinkverwaltung.vue'
import WidgetBmfwfSeiteMerken from './WidgetBmfwfSeiteMerken.vue'
import WidgetBmbLinkanzeige from './WidgetBmbLinkanzeige.vue'
import WidgetBmbLinkverwaltung from './WidgetBmbLinkverwaltung.vue'
import WidgetBmbSeiteMerken from './WidgetBmbSeiteMerken.vue'
import WidgetBhagLinkanzeige from './WidgetBhagLinkanzeige.vue'
import WidgetBhagLinkverwaltung from './WidgetBhagLinkverwaltung.vue'
import WidgetBhagSeiteMerken from './WidgetBhagSeiteMerken.vue'
import WidgetLikesAndComments from './WidgetLikesAndComments.vue'
import WidgetLikesAndCommentsCounter from './WidgetLikesAndCommentsCounter.vue'

createWidgets([
  {
    name: 'bhag-linkanzeige',
    widget: WidgetBhagLinkanzeige,
    store: sharedStore,
    i18n: false
  },
  {
    name: 'bhag-linkverwaltung',
    widget: WidgetBhagLinkverwaltung,
    store: sharedStore,
    i18n: false
  },
  {
    name: 'bhag-seitemerken',
    widget: WidgetBhagSeiteMerken,
    store: sharedStore,
    i18n: false
  },
  {
    name: 'bmb-linkanzeige',
    widget: WidgetBmbLinkanzeige,
    store: sharedStore,
    i18n: false
  },
  {
    name: 'bmb-linkverwaltung',
    widget: WidgetBmbLinkverwaltung,
    store: sharedStore,
    i18n: false
  },
  {
    name: 'bmb-seitemerken',
    widget: WidgetBmbSeiteMerken,
    store: sharedStore,
    i18n: false
  },
  {
    name: 'bmfwf-linkanzeige',
    widget: WidgetBmfwfLinkanzeige,
    store: sharedStore,
    i18n: false
  },
  {
    name: 'bmfwf-linkverwaltung',
    widget: WidgetBmfwfLinkverwaltung,
    store: sharedStore,
    i18n: false
  },
  {
    name: 'bmfwf-seitemerken',
    widget: WidgetBmfwfSeiteMerken,
    store: sharedStore,
    i18n: false
  },
  {
    name: 'anwendungs-favoriten',
    widget: WidgetAnwendungsFavoriten,
    store: sharedStore,
    i18n: false
  },
  {
    name: 'anwendungs-liste',
    widget: WidgetAnwendungsListe,
    store: sharedStore,
    i18n: false
  },
  {
    name: 'betriebsmitteilungen',
    widget: WidgetBetriebsmitteilungen,
    store: sharedStore,
    i18n: false
  },
  {
    name: 'rssfindok',
    widget: WidgetRSSFindok,
    store: sharedStore,
    i18n: false
  },
  {
    name: 'search',
    widget: WidgetSearch,
    store: sharedStore,
    i18n: true
  },
  {
      name: 'searchvab',
      widget: WidgetSearchVab,
      store: sharedStore,
      i18n: true
  },
  {
      name: 'searchbhagintranet',
      widget: WidgetSearchBhagIntranet,
      store: sharedStore,
      i18n: true
  },
  {
    name: 'likes-and-comments',
    widget: WidgetLikesAndComments,
    store: sharedStore,
    i18n: false
  },
  {
    name: 'likes-and-comments-counter',
    widget: WidgetLikesAndCommentsCounter,
    store: sharedStore,
    i18n: false
  }
])
